/**
 * Technology & Digital Reach Translations Module (English)
 * 
 * Contains: Website Analytics, Social Media, LEADER Magazine, Technology Trends
 * 
 * @module technology
 * @language en
 */

export const technology = {
  technologyFuture: {
    pageTitle: "Technology & Digital Reach",
    pageSubtitle: "JCI.cc • Social Media • LEADER Magazine | 260K+ followers, 70+ countries"
  },
  technologyRole: {
    title: "Technology Role",
    subtitle: "How JCI uses technology to connect and empower young leaders",
    new: "NEW"
  },
  programs: {
    jciWebsite: "JCI.cc Website",
    website: "Website",
    socialMedia: "Social Media",
    social: "Social",
    leaderMagazine: "LEADER Magazine",
    magazine: "Magazine",
    activeUsers: "Active Users",
    pageViews: "Page Views",
    avgSession: "Avg Session",
    bounceRate: "Bounce Rate",
    returnVisitors: "Return Visitors",
    mobileAccess: "access via mobile",
    mobileFirstApproach: "Mobile-first approach essential",
    deviceBreakdown: "Device Breakdown",
    trafficSources: "Traffic Sources",
    topGeographicSources: "Top Geographic Sources",
    largest: "Largest",
    topPagesVisited: "Top Pages Visited",
    combinedFollowers: "Combined Followers",
    monthlyImpressions: "Monthly Impressions",
    organicGrowth: "Organic Growth",
    avgEngagement: "Avg Engagement",
    followers: "Followers",
    topContent: "Top Content",
    topVideo: "Top Video",
    views: "views",
    retention: "retention",
    totalReaders: "Total Readers",
    bookVisits: "Book Visits",
    avgReadTime: "Avg Read Time",
    countries: "Countries",
    keyInsight: "Key Insight",
    readersPerIssue: "Readers Per Issue (7 Issues, Jan-Oct 2025)",
    readTimeTrend: "Read Time Trend (Increasing Engagement)",
    deviceAccess: "Device Access",
    regionalReach: "Regional Reach",
    contentThemes: "Content Themes",
    devices: {
      desktopLaptop: "Desktop/Laptop",
      mobilePhone: "Mobile Phone",
      tablet: "Tablet"
    },
    trafficSourceTypes: {
      organicSearch: "Organic Search",
      direct: "Direct",
      referral: "Referral",
      paid: "Paid",
      goodSeoVisibility: "Good SEO visibility",
      strongBrandRecognition: "Strong brand recognition",
      socialPartnerships: "Social + partnerships",
      limitedCampaigns: "Limited campaigns"
    },
    topPagesData: {
      aboutJci: "About JCI",
      newsEvents: "News & Events",
      whatWeDo: "What We Do",
      programsPage: "Programs",
      getInvolved: "Get Involved",
      discoveringOrg: "People discovering the org",
      engagementSeeking: "Engagement seeking",
      programInterest: "Program interest",
      actionOriented: "Action-oriented visitors",
      ctaMomentum: "Call-to-action momentum"
    }
  },
  socialMediaData: {
    communityHub: "Community Hub",
    visualStorytelling: "Visual Storytelling",
    thoughtLeadership: "Thought Leadership",
    longFormContent: "Long-form Content",
    fastestGrowth: "Fastest Growth",
    consistentGrowth: "Consistent Growth",
    eventHighlights: "Event highlights",
    memberStories: "Member stories",
    campaigns: "Campaigns",
    reels: "Reels (3x engagement)",
    visualStories: "Visual stories",
    leadershipInsights: "Leadership insights",
    partnerships: "Partnerships",
    trainingSessions: "Training sessions",
    reach: "reach",
    engagement: "engagement",
    impressions: "impressions",
    interactions: "interactions",
    watchTime: "watch time",
    whatIsJci: "What is JCI?"
  },
  futureSkills: {
    communicationPublicSpeaking: "Communication & Public Speaking",
    communicationDesc: "Essential for leadership and influence",
    criticalThinking: "Critical Thinking & Problem Solving",
    criticalThinkingDesc: "Analytical skills for complex challenges",
    conflictResolution: "Conflict Resolution & Negotiation",
    conflictResolutionDesc: "Managing disputes and building consensus",
    projectManagement: "Project Management",
    projectManagementDesc: "Planning and executing initiatives effectively",
    digitalTechLiteracy: "Digital & Tech Literacy",
    digitalTechDesc: "Understanding modern technology tools",
    financialLiteracy: "Financial Literacy",
    financialLiteracyDesc: "Managing budgets and financial planning",
    interculturalCommunication: "Intercultural Communication",
    interculturalDesc: "Working effectively across cultures",
    advocacyInfluence: "Advocacy & Influence",
    advocacyDesc: "Driving change through persuasion"
  },
  technology: {
    title: "Technology & Future",
    subtitle: "Technology adoption and future innovation trends",
    memberProfile: "Member Technology Profile",
    engagementMembers: "Member Engagement",
    aiInLeadership: "AI in Leadership",
    transformative: "Transformative",
    aiDescription: "AI tools for decision-making, personalized learning, and automation are reshaping how young leaders develop and lead.",
    digitalFirstSkills: "Digital-First Skills",
    critical: "Critical",
    digitalDescription: "Data literacy, digital marketing, programming, and cybersecurity are now essential skills for career advancement.",
    sustainabilityGreenTech: "Sustainability & Green Tech",
    essential: "Essential",
    sustainabilityDescription: "Climate tech, renewable energy, and circular economy solutions driving environmental sustainability.",
    mentalHealthTech: "Mental Health Tech",
    growing: "Growing",
    mentalHealthDescription: "Mental wellness apps, teletherapy platforms, and AI chatbots providing accessible mental health support.",
    keyFocusAreas: "Key Focus Areas",
    source: "Source",
    trendsResearchSources: "Trends Research Sources",
    futureSkillsPriorities: "Future Skills Priorities 2025",
    futureSkillsSubtitle: "Essential competencies identified by JCI members for leadership development and career success",
    priority: "Priority",
    skillsDevelopmentFramework: "Skills Development Framework",
    skillsFrameworkDesc: "These priorities guide JCI's training programs, workshops, and leadership development initiatives. Members identified these competencies as most critical for navigating the evolving challenges of 2025 and beyond, with particular emphasis on communication, critical thinking, and digital literacy.",
    veryHigh: "Very High",
    high: "High",
    medium: "Medium",
    mediumHigh: "Medium-High",
    emerging: "Emerging",
    // AI Focus Areas
    aiAugmentedDecision: "AI-augmented decision making",
    personalizedLearning: "Personalized learning paths",
    automatedAnalytics: "Automated analytics",
    ethicalAiGovernance: "Ethical AI governance",
    // Digital Skills Focus Areas
    dataLiteracy: "Data literacy",
    digitalMarketing: "Digital marketing",
    programmingBasics: "Programming basics",
    cybersecurityAwareness: "Cybersecurity awareness",
    // Green Tech Focus Areas
    climateTechnology: "Climate technology",
    renewableEnergy: "Renewable energy",
    circularEconomy: "Circular economy",
    esgMeasurement: "ESG measurement",
    // Mental Health Tech Focus Areas
    wellnessApplications: "Wellness applications",
    teletherapyPlatforms: "Teletherapy platforms",
    aiSupportChatbots: "AI support chatbots",
    stressManagementTools: "Stress management tools"
  }
} as const;

